import React from 'react';
import { Modal, Button, Alert, Table, Badge } from 'react-bootstrap';

const IrmPeriodOverlapModal = ({ show, onHide, overlapData, onConfirm, isLoading }) => {
    const formatDate = (dateString) => {
        return new Date(dateString).toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'short',
            day: 'numeric'
        });
    };

    const getStatusBadge = (status) => {
        switch (status) {
            case 1:
                return <Badge bg="success">Success</Badge>;
            case 2:
                return <Badge bg="warning">Processing</Badge>;
            case 3:
                return <Badge bg="danger">Failed</Badge>;
            default:
                return <Badge bg="secondary">Unknown</Badge>;
        }
    };

    return (
        <Modal
            show={show}
            onHide={onHide}
            size="lg"
            centered
            backdrop="static"
        >
            <Modal.Header closeButton>
                <Modal.Title>
                    Period Overlap Detected
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Alert variant="warning" className="mb-3">
                    <strong>Warning:</strong> The selected period overlaps with {overlapData?.total_periods || 0} existing period(s).
                </Alert>

                <p className="mb-3">
                    Creating this period may result in duplicate IRM records across different periods.
                </p>

                {overlapData?.overlapping_periods && overlapData.overlapping_periods.length > 0 && (
                    <div className="mb-3">
                        <h6 className="fw-bold">Overlapping Periods:</h6>
                        <Table bordered size="sm" className="mb-0">
                            <thead className="table-light">
                                <tr>
                                    <th>Period</th>
                                    <th>Status</th>
                                    <th className="text-end">IRM Count</th>
                                </tr>
                            </thead>
                            <tbody>
                                {overlapData.overlapping_periods.map((period) => (
                                    <tr key={period.id}>
                                        <td>
                                            <strong>{formatDate(period.start_date)}</strong> to <strong>{formatDate(period.end_date)}</strong>
                                        </td>
                                        <td>{getStatusBadge(period.status)}</td>
                                        <td className="text-end">
                                            <Badge bg="info">{period.irm_count} IRMs</Badge>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </div>
                )}

                <div className="mt-3">
                    <p className="mb-0 fw-bold">Do you want to continue creating this period?</p>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide} disabled={isLoading}>
                    No, Cancel
                </Button>
                <Button variant="primary" onClick={onConfirm} disabled={isLoading}>
                    {isLoading ? (
                        <>
                            <div className="spinner-border spinner-border-sm me-2" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                            Creating...
                        </>
                    ) : (
                        'Yes, Continue'
                    )}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default IrmPeriodOverlapModal;